

var _squid = require('squid');

define(['jquery', 'angular', 'squid/module', './lib/mapper', 'text!./template.html', './occupation/directive', 'guest/nationality/directive', 'components/xo-models/src/fi/index', 'components/xo-models/src/onboard/index', 'components/xo-tracking/dist/index', 'components/xo-form-components/src/phone/directive', 'components/xo-page-components/src/footer/directive', 'components/xo-ui-components/src/tooltip/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-ui-components/src/spinner/directive', 'components/xo-form-components/src/dob-input/directive', 'components/xo-address-components/src/add-address/directive', 'components/xo-page-components/src/value-props/directive', 'components/xo-return-to-merchant/dist/util', 'guest/emailInput/directive', 'guest/passwordInput/directive', 'components/xo-address-components/src/address-normalization/directive', 'components/xo-form-components/src/national-id-input/directive', 'components/xo-form-components/src/place-of-birth/directive', 'components/xo-form-components/src/gender-type/directive'], function ($, angular, module, mapper, template) {

    return angular.module('xo-guest-upgrade.directive', ['squid', 'xomodel.fi', 'tracking.fpti', 'xomodel.onboard', 'xo-phone.phoneInput', 'xo-footer.directive', 'xo-guest.emailInput', 'xo-tooltip.directive', 'xo-spinner.directive', 'xo-message.directive', 'xo-return-to-merchant', 'xo-guest.passwordInput', 'xo-dob-input.directive', 'xo-value-props.directive', 'xo-add-address.directive', 'xo-guest-upgrade.occupation', 'xo-guest.nationality', 'xo-address-normalization.directive', 'xo-national-id-input.directive', 'xo-gender-type.directive', 'xo-place-of-birth.directive']).directive('xoGuestUpgrade', function ($rootScope, $ReturnToMerchant, $OnboardUserModel, $OnboardPhoneModel, $GuestUpgradeModel, $BillingAddressModel) {

        return {

            template: template,

            scope: {
                token: '='
            },

            controller: function controller($q, $fpti, $scope, $util, $state, $config, $logger, $window, $pxpMatch, $locale, $interval, $rootScope, // eslint-disable-line no-shadow
            $renderContent, $NationalIdModel) {
                var _this = this;

                var modelSchema = void 0;
                var fpti = {
                    trackSuccess: function trackSuccess() {
                        this.track(':success');
                    },
                    trackError: function trackError(err) {
                        this.track(':error', err);
                    },
                    track: function track(suffix, err) {
                        var error = void 0;
                        if (err) {
                            error = {
                                type: 'pageError',
                                msg: err.message
                            };
                        }
                        $state.current.trackingData.buzname.guestupgrade.pagename2 = $state.current.trackingData.buzname.guestupgrade.pagename2 + suffix;
                        $fpti.setupDataString($state.current, error);
                    }
                };
                var options = {
                    params: {
                        data: $util.param('data')
                    }
                };

                $scope.upgradeFromEmail = $util.param('data').length === 15 || $util.param('data').length === 16 ? true : false;
                $scope.flags = { singlePassword: false };
                $scope.locale = $locale;
                $scope.merchant = $locale.content.get('signup.ebay');
                $scope.returnToMerchantTimerMsg = '';
                $scope.valueTitle = $renderContent('guestVerify.propHead');
                $scope.valueText = $renderContent('guestVerify.propVal');
                $scope.pageTitle = $scope.upgradeFromEmail ? $scope.locale.content.guestUpgrade.emailFlowTitle : $scope.locale.content.signup.title;
                $scope.footerStyle = 'fullFooter';

                // Do not show cancel URL if experience is set to minibrowser
                if (!$rootScope.miniBrowser) {
                    $scope.cancelUrl = $util.param('cancel_url');
                }

                // Change the message of the overlay on the site that lauched this flow.
                $ReturnToMerchant.postToMerchant({
                    secureWindowmsg: $locale.content.get('signup.overlayMsg')
                });

                function showSuccessPage() {
                    // This changes the footer wapper ID and appropriate css classes gets applied
                    $scope.footerStyle = 'confirmationFooter';

                    if (!$scope.upgradeFromEmail) {
                        var timerExecutor = function timerExecutor() {
                            // eslint-disable-line no-inner-declarations
                            // We wait for 5 secs on live and 10 secs on stage/local(helpful for automation)
                            var waitTime = $config.deploy.isLive() ? 20 : 10;

                            function updateMsg() {
                                $scope.returnToMerchantTimerMsg = $renderContent('signup.returnTimerMsg', {
                                    waitTime: waitTime
                                });
                            }

                            $scope.stopTimerAndRedirect = function () {
                                if (angular.isDefined(timer)) {
                                    $interval.cancel(timer);
                                    timer = undefined;
                                }
                                $ReturnToMerchant.goTo($scope.successUrl);
                            };

                            updateMsg();
                            // When $scope.onboard becomes null, the success page is shown.
                            $scope.onboard = null;

                            return function () {
                                waitTime -= 1;
                                updateMsg();
                                if (waitTime === 0) {
                                    return $scope.stopTimerAndRedirect();
                                }
                            };
                        };

                        var timer = void 0;

                        $scope.successUrl = $util.buildURL($util.param('return_url'), {
                            status: 'success'
                        });

                        fpti.trackSuccess();
                        $ReturnToMerchant.postToMerchant($scope.successUrl);

                        timer = $interval(timerExecutor(), 1000);
                    } else {
                        // When $scope.onboard becomes null, the success page is shown.
                        $scope.onboard = null;
                    }
                }

                function handleUIValidation(errorData, displayGenericMessage) {
                    var element = mapper.errorMapper(errorData);
                    if (element) {
                        var $fields = $(element);
                        $fields.addClass('backendError');
                    }
                    if (displayGenericMessage) {
                        $scope.pageErrorMsg = { msgs: [$scope.locale.content.genericError.incontextGenericPageError], type: 'error' };
                    }
                }

                function upgrade() {
                    var data = $scope.upgradeFromEmail ? $scope.onboard.serializeEmailFlow() : $scope.onboard.serialize();

                    $scope.onboard.save({
                        data: data,
                        success: showSuccessPage,
                        contingencies: {
                            DOB_INVALID: function DOB_INVALID(err, message) {
                                handleUIValidation(err);
                                $scope.pageErrorMsg = { msgs: [$scope.locale.content.validation.validDOB], type: 'error' };
                            },
                            PHONE_INVALID: function PHONE_INVALID(err, message) {
                                handleUIValidation(err);
                                $scope.pageErrorMsg = { msgs: [$scope.locale.content.validation.validPhone], type: 'error' };
                            },
                            NATID_INVALID: function NATID_INVALID(err, message) {
                                handleUIValidation(err);
                                $scope.pageErrorMsg = { msgs: [$scope.locale.content.validation.validNationalId], type: 'error' };
                            },
                            ADDRESS_LINEONE_INVALID: function ADDRESS_LINEONE_INVALID(err, message) {
                                handleUIValidation(err, true);
                            },
                            ADDRESS_CITY_INVALID: function ADDRESS_CITY_INVALID(err, message) {
                                handleUIValidation(err, true);
                            },
                            ADDRESS_STATE_INVALID: function ADDRESS_STATE_INVALID(err, message) {
                                handleUIValidation(err, true);
                            },
                            ADDRESS_POSTAL_CODE_INVALID: function ADDRESS_POSTAL_CODE_INVALID(err, message) {
                                handleUIValidation(err, true);
                            },
                            PASSWORD_INVALID: function PASSWORD_INVALID(err, message) {
                                handleUIValidation(err, true);
                            },
                            FI_INVALID: function FI_INVALID(err, message) {
                                handleUIValidation(err);
                            },
                            DEFAULT: function handleContingency(name, contingency) {
                                $logger.info('guest_upgrade_contingency', {
                                    'int_error_description': contingency && contingency.message,
                                    'contingency_name': name
                                });
                            }
                        }
                    })['catch'](function (err) {
                        fpti.trackError(err);

                        $logger.error('guest_upgrade_error', { error: err });

                        if ($util.param('return_url')) {
                            var url = $util.buildURL($util.param('return_url'), {
                                status: 'fail'
                            });

                            $scope.cancelUrl = url;

                            $ReturnToMerchant.postToMerchant({
                                cancelUrl: url
                            });
                        }
                    });
                }

                function getContentIdentifier() {
                    return [$locale.country, $locale.lang, (0, _squid.$contentVersion)(), 'signupTerms.easySignupTCPA'].join(':');
                }

                function setTCPAFlags() {
                    $scope.flags.tcpa_content = false;

                    if ($scope.locale.country === 'US') {
                        $scope.flags.tcpa_content = true;
                    }

                    $logger.info('guest_upgrade_tcpa', {
                        tcpa: $scope.flags.tcpa_content,
                        content_identifier: $scope.onboard.contentIdentifier,
                        experience_identifier: $scope.onboard.experienceIdentifier
                    });
                }

                modelSchema = {
                    user: new $OnboardUserModel({
                        country: $locale.country,
                        nationality: $locale.country
                    }),

                    phone: new $OnboardPhoneModel(),

                    billing_address: $BillingAddressModel.create(null, {
                        country: $locale.country
                    })
                };

                $scope.onboard = new $GuestUpgradeModel(modelSchema);

                $scope.onSubmit = function () {
                    if ($scope.specialFields.nationalId) {
                        $scope.onboard.nationalIdModel = $NationalIdModel.instance($rootScope.token);
                    }

                    if ($scope.specialFields.address) {
                        $scope.showAddressNormalizationLightbox = true;
                        return;
                    }

                    upgrade();
                };

                $GuestUpgradeModel.instance().retrieve(options).then(function (preloadedData) {
                    if (preloadedData.guestUpgradeNewAppRedirect === true) {
                        var redirectUrl = window.location.href.replace('xoonboarding', 'prox');
                        $logger.info('guest_upgrade_new_app_redirect', {
                            redirectUrl: redirectUrl,
                            transactionId: preloadedData.transaction
                        });
                        return $util.redirect(redirectUrl);
                    }
                    $scope.onboard.payerId = preloadedData.payerId;
                    $scope.onboard.billing_address.populate(mapper.getFormattedAddress(preloadedData.billing_address));
                    $scope.onboard.user.populate(preloadedData.user);
                    $scope.specialFields = mapper.getSpecialFieldsFor(preloadedData.user.country);
                    $scope.onboard.contentIdentifier = getContentIdentifier();

                    setTCPAFlags();

                    if ($scope.upgradeFromEmail) {
                        // Email based gxo flow

                        $scope.onboard.card = preloadedData.card;
                        $scope.onboard.receiptId = preloadedData.receiptId;
                        $scope.onboard.transaction = preloadedData.transaction;
                        $scope.onboard.experienceIdentifier = 'proxemailupgrade';
                    } else {
                        // Ad based gxo flow

                        // Check if return_url and cancel_url are present and if the session has timed out
                        if (!$util.param('cancel_url') || !$util.param('return_url') || !preloadedData.email || !preloadedData.payerId || !preloadedData.transaction) {
                            fpti.trackError(new Error('malformed payload'));
                            $state.go('guestupgrade.genericError', {
                                code: 'GUEST_UPGRADE_SESSION_ERROR'
                            });
                            return;
                        }
                        mapper.pxpMapper($scope, $pxpMatch, preloadedData);
                        $scope.onboard.transaction = preloadedData.transaction;
                        $scope.onboard.experienceIdentifier = 'proxupgrade';

                        $logger.info('guest_upgrade_ui_fields', {
                            special_fields: $scope.specialFields,
                            txn_id: preloadedData.transaction
                        });

                        if ($scope.specialFields.address) {
                            $scope.uponNormalization = function (normalizedAddress, isBack) {
                                $scope.showAddressNormalizationLightbox = false;

                                // Update the new address
                                $scope.onboard.billing_address = $BillingAddressModel.create(null, normalizedAddress, {
                                    id: '0',
                                    normalization_status: normalizedAddress.normalization_status
                                });

                                upgrade();
                            };
                        }
                    }
                });

                $rootScope.$on('allLoaded', function () {
                    document.getElementById('preloaderSpinner').style.display = 'none';
                });

                $scope.formatExpiry = function (event) {
                    var key = event.keyCode || event.charCode;
                    var $el = $(event.target);
                    var val = $el.val().replace(/[^0-9\/]/gi, '');
                    var strokes = val.length;

                    // Ignore delete keys
                    if (key === 8 || key === 46) {
                        return;
                    }

                    // after two characters add a slash char
                    if (strokes === 2) {
                        val += '/';
                    }

                    _this.expiryDate = val;
                    $el.mask('99/99');
                };

                var currentYear = new Date().getFullYear().toString();
                var validMonths = $util.map($util.range(1, 13), function (num) {
                    return ('0' + num).substr(-2);
                });

                $scope.validate = function (expiryDate) {
                    if (!expiryDate) {
                        return;
                    }

                    var month = void 0,
                        year = void 0,
                        unformatted = void 0;
                    var isValid = false;

                    unformatted = expiryDate.replace(/[^0-9]/gi, '');
                    if (unformatted.length > 3) {
                        month = unformatted.substring(0, 2);
                        year = currentYear.substring(0, 2) + unformatted.substring(2, 4);

                        isValid = validMonths.indexOf(month) > -1 && year >= currentYear;

                        if (isValid) {
                            var expDate = new Date(year, parseInt(month, 10) - 1);
                            var today = new Date();
                            isValid = expDate > today;
                        }
                    }

                    return isValid;
                };
            }
        };
    });
});

_squid.$contentVersion;


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade/directive.js
// module id = ./components/xo-guest-components/src/guest-upgrade/directive.js
// module chunks = 1